import React, { useState } from "react";
import { TopBar } from "./TopBar/TopBar";
import { MenuListItems } from "./MenuBar/MenuListItem";
import { MainContent } from "./MainWrapper/MainContent";

export const Layout = ({ children }) => {
  // State for sidebar collapse and user dropdown
  const [openSidebar, setOpenSidebar] = useState(false);
  // Handle sidebar toggle
  const toggleSidebar = () => {
    setOpenSidebar(!openSidebar);
  };
  return (
    <div>
      <TopBar toggleSideBarAction={toggleSidebar} />
      <MenuListItems
        toggleSideBarAction={toggleSidebar}
        isSideBarIsOpen={openSidebar}
        parentMenu={"parentMenu"}
      />
      <MainContent>{children}</MainContent>
    </div>
  );
};
